/**
 * There are two types of wait: implicit and explicit.
 * - Explicit waits are waits that you explicitly tell to start and stop with
 *   the explicit wait actions. Examples include switching tasks in a lesson
 *   and the loading message that appears in parent portal.
 * - Implicit waits are waits that appear automatically if code called in a
 *   wCall within a saga takes a little while to run.
 */

export const START_IMPLICIT_WAITING = 'START_IMPLICIT_WAITING';
export const SHOW_IMPLICIT_WAITING = 'SHOW_IMPLICIT_WAITING';
export const STOP_IMPLICIT_WAITING = 'STOP_IMPLICIT_WAITING';
export const RESET_IMPLICIT_WAITING = 'RESET_IMPLICIT_WAITING';
export const START_EXPLICIT_WAITING = 'START_EXPLICIT_WAITING';
export const STOP_EXPLICIT_WAITING = 'STOP_EXPLICIT_WAITING';
export const STOP_EXPLICIT_WAITING_WITH_DELAY = 'STOP_EXPLICIT_WAITING_WITH_DELAY';

export function startImplicitWaiting() {
    return { type: START_IMPLICIT_WAITING };
}

export function showImplicitWaiting() {
    return { type: SHOW_IMPLICIT_WAITING };
}

export function stopImplicitWaiting() {
    return { type: STOP_IMPLICIT_WAITING };
}

export function resetImplicitWaiting() {
    return { type: RESET_IMPLICIT_WAITING };
}

/**
 * Sets a waiting message which appears on a screen whilst the app is
 * waiting for something to happen
 * @param message the message string. If null, there is no waiting message
 * @param transparent If true, the waiting overlay is partially transparent.
 */
export function startExplicitWaiting(message = null, transparent = false) {
    return { type: START_EXPLICIT_WAITING, message, transparent };
}

/**
 * Clears the waiting message immediately.
 */
export function stopExplicitWaiting() {
    return { type: STOP_EXPLICIT_WAITING };
}

/**
 * Clears the waiting message, but ensures it is present for a short while
 * so it doesn't appear to flicker.
 * @param delay ensure we wait for at least x seconds
 */
export function stopExplicitWaitingWithDelay(delay = 1) {
    return { type: STOP_EXPLICIT_WAITING_WITH_DELAY, delay };
}
